export default {
  install: (app, options) => {
    const isMaintenanceError = (response) => {
      return response.data?.error === "maintenance";
    };

    const translateSbkLoginError = (error) => {
      if (!error || error.error !== "error") {
        return "onboarding.login.screen.login.error";
      }

      const errorMessage = JSON.parse(error.message);
      switch (errorMessage.message) {
        case "Invalid credentials.":
          return "onboarding.login.screen.login.error";
        case "You account is not activated yet. Click on the link in the email or request a new one.":
          return "ssosbk.login.error.accountNotActivated";
        case "The campaign you registered for has not yet started.":
          return "ssosbk.login.error.campaignNotStarted";

        /*  BKKC-1690
        case "You are not yet registered for a campaign in this portal. Please register first through a registration link with your existing login credentials.":
          return "ssosbk.login.error.registerFirst";
        case "The campaign you registered for has not yet started.":
          return "ssosbk.login.error.campaignNotStarted";
        case "The campaign you registered for is deactivated. Register for a new campaign with your existing user credentials to start a new one.":
          return "ssosbk.login.error.campaignDeactivated";
        case "You removed your data consent for the currently active campaign. Data consent is required to use this portal.":
          return "ssosbk.login.error.noConsent";
        case "Giving data consent is required to join a campaign.":
          return "ssosbk.login.error.dataConsentRequired";
        case "You are already registered for another running campaign on this portal.":
          return "ssosbk.login.error.alreadyRegistered";
        case "Registration for this campaign is closed.":
          return "ssosbk.login.error.campaignClosed";
        case "Es existiert bereits ein Account mit dieser E-Mail.":
          return "ssosbk.register.new.emailinuse";
  */

        default:
          return "onboarding.login.screen.login.error";
      }
    };

    const translateSbkRegistrationError = (error) => {
      if (!error) {
        return null;
      }

      switch (error) {
        case "Es existiert bereits ein Account mit dieser E-Mail.":
          return "ssosbk.register.new.emailinuse";
        default:
          return error;
      }
    };

    app.config.globalProperties.$sbkManager = {
      translateSbkLoginError,
      translateSbkRegistrationError,
      isMaintenanceError,
    };
  },
};
